import {
  httpsCallable,
  getFunctions,
  connectFunctionsEmulator,
} from "firebase/functions";
import { CloudFunctions, FirestoreDB, FirebaseAuth } from "utils/firebase";
import axios from "axios";
import { COMPANY_NAME } from "./constants";
import {
  addDoc,
  collection,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
  setDoc,
} from "firebase/firestore";

if (process.env["REACT_APP_FUNCTIONS_EMULATOR"]) {
  console.log("CONNECTING TO EMULATOR");
  connectFunctionsEmulator(getFunctions(), "127.0.0.1", 5001);
}

export const getTeamListForMeetingNotes = async (loginEmail) => {
  try {
    const getMyTeam = httpsCallable(CloudFunctions, "getMyTeam");

    const response = await getMyTeam({
      email: loginEmail,
    });
    if (response.data.status) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const checkUserOrganization = async (loginEmail) => {
  try {
    const checkIfUserHasExistingOrganization = httpsCallable(
      CloudFunctions,
      "checkIfUserHasExistingOrganization",
    );
    const response = await checkIfUserHasExistingOrganization({
      email: loginEmail,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const ValidateUserInputs = async (
  loginEmail,
  fname,
  lname,
  department,
) => {
  try {
    const ValidateUserAndConnectToFinch = httpsCallable(
      CloudFunctions,
      "ValidateUserAndConnectToFinch",
    );

    const response = await ValidateUserAndConnectToFinch({
      email: loginEmail,
      firstName: fname,
      lastName: lname,
      department: department,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const MeetingDetails = async (
  email = "",
  meetingIds = [],
  orgId = "",
) => {
  try {
    const getMeetingDetails = httpsCallable(
      CloudFunctions,
      "getMeetingDetails",
    );

    const response = await getMeetingDetails({
      meetingIds,
      email,
      orgId,
    });
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const SendRunningLate = async (data) => {
  try {
    const SendRunningLateEmail = httpsCallable(
      CloudFunctions,
      "sendRunningLateEmail",
    );

    const response = await SendRunningLateEmail(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const AddMeetingNotes = async (loginEmail, meetingId, meetingNotes) => {
  try {
    const addMeetingNotesData = httpsCallable(
      CloudFunctions,
      "addMeetingNotesData",
    );
    const response = await addMeetingNotesData({
      email: loginEmail,
      meeting_Id: meetingId,
      meeting_Notes: meetingNotes,
    });
    return response;
  } catch (e) {
    console.log(e);
    throw e;
  }
};
export const connectToFinch = async (
  loginEmail,
  orgnizationID,
  finchId,
  userUid,
) => {
  try {
    const connectToFinch = httpsCallable(CloudFunctions, "connectToFinch");
    const response = await connectToFinch({
      email: loginEmail,
      orgId: orgnizationID,
      finchId: finchId,
      userUid: userUid,
    });
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const connectToFinchV2 = async (loginEmail, userUid) => {
  try {
    const connectToFinchV2 = httpsCallable(CloudFunctions, "connectToFinchV2");
    const response = await connectToFinchV2({
      email: loginEmail,
      userUid,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getTags = async (userUid, plan, orgnizationID, department) => {
  try {
    const getTags = httpsCallable(CloudFunctions, "getTags");
    const response = await getTags({
      userUid: userUid,
      userPlan: plan,
      orgId: orgnizationID,
      department: department,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const addActionItem = async (
  fromUserEmail = null,
  toUserEmail,
  html,
  priority = 2,
  effort = 2,
  due_date = null,
) => {
  try {
    const addActionItemFunction = httpsCallable(
      CloudFunctions,
      "addActionItem",
    );
    const response = await addActionItemFunction({
      email: toUserEmail,
      html: html,
      priority: priority,
      effort: effort,
      due_date: due_date,
      assigned_user: fromUserEmail,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const sendInvitationsToEmails = async (
  user_Uid,
  from_Email,
  to_emails,
) => {
  try {
    const createAndSendInviteLinkEmails = httpsCallable(
      CloudFunctions,
      "createAndSendInviteLinkEmails",
    );
    const response = await createAndSendInviteLinkEmails({
      uid: user_Uid,
      fromEmail: from_Email,
      toEmails: to_emails,
    });
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const SendEmailNotes = async (data) => {
  try {
    const SendEmailNotes = httpsCallable(
      CloudFunctions,
      "sendMeetingNotesEmail",
    );

    const response = await SendEmailNotes(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const SendEmailSummary = async (data) => {
  try {
    const SendEmailSummary = httpsCallable(
      CloudFunctions,
      "sendMeetingSummaryEmail",
    );

    const response = await SendEmailSummary(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const sendAssistantEmailDraft = async (data) => {
  try {
    const sendAssistantEmailDraftFn = httpsCallable(
      CloudFunctions,
      "sendAssistantEmailDraft",
    );

    const response = await sendAssistantEmailDraftFn(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const sendActionItems = async (data) => {
  try {
    const sendActionItemsEmail = httpsCallable(
      CloudFunctions,
      "sendActionItemsEmail",
    );

    const response = await sendActionItemsEmail(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const respondToInvitation = async (
  invitationFromUID,
  invitationToUID,
  invitationToEmailID,
  status,
  loginEmail,
) => {
  try {
    const respondToInvitation = httpsCallable(
      CloudFunctions,
      "respondToInvitation",
    );

    const response = await respondToInvitation({
      fromUserID: invitationFromUID,
      toUserID: invitationToUID || "",
      toEmailID: invitationToEmailID,
      status: status,
      loginEmail: loginEmail,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const decryptInviteTokenAndReturnUsers = async (token) => {
  try {
    const decryptInviteTokenAndReturnUsers = httpsCallable(
      CloudFunctions,
      "decryptInviteTokenAndReturnUsers",
    );

    const response = await decryptInviteTokenAndReturnUsers({
      token: token,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const slackChannelsList = async () => {
  try {
    const slackChannelsList = httpsCallable(
      CloudFunctions,
      "listSlackChannels",
    );
    const response = await slackChannelsList();
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const slackUsersList = async () => {
  try {
    const slackUsersList = httpsCallable(CloudFunctions, "listSlackUsers");
    const response = await slackUsersList();
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const SendSlackNotes = async (data) => {
  try {
    const postMessageToSlack = httpsCallable(
      CloudFunctions,
      "postMessageToSlack",
    );

    const response = await postMessageToSlack(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getCostOfUserMeetings = async (email, type, duration) => {
  try {
    const costOfUserMeetings = httpsCallable(
      CloudFunctions,
      "costOfUserMeetings2",
    );

    const response = await costOfUserMeetings({
      userEmail: email,
      asAn: type,
      pastDays: duration,
    });
    return response.data.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getNoAndHoursOfMeetings = async (type, userEmail) => {
  try {
    const noAndHrsOfMeetings = httpsCallable(
      CloudFunctions,
      "noAndHrsOfMeetings",
    );

    const res = await noAndHrsOfMeetings({
      asAn: type,
      userEmail,
    });
    return res.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getIndividualRating = async (email, type, duration) => {
  try {
    const rating = httpsCallable(CloudFunctions, "getIndividualRating2");
    const res = await rating({
      userEmail: email,
    });
    return res.data.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getDirectReportees = async (email, duration) => {
  try {
    const directReportees = httpsCallable(
      CloudFunctions,
      "getDirectReportees2",
    );
    const res = await directReportees({
      userEmail: email,
      pastDays: duration,
    });
    return res.data.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getCompleteOrgChart = async (email) => {
  try {
    const getCompleteOrgChart = httpsCallable(
      CloudFunctions,
      "getCompleteOrgChart",
    );
    const res = await getCompleteOrgChart({
      userEmail: email,
    });
    return res.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const mapUserToFinch = async (email, finchId) => {
  try {
    const tempMapUserToFinch = httpsCallable(
      CloudFunctions,
      "tempMapUserToFinch",
    );
    const res = await tempMapUserToFinch({
      email: email,
      finchId: finchId,
      companyName: COMPANY_NAME,
    });
    return res.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const fetchMeetingDisForUser = async (userEmail, duration, asAn) => {
  try {
    const distributionOfMeetingsForUser = httpsCallable(
      CloudFunctions,
      "distributionOfMeetingsForUser2",
    );
    const res = await distributionOfMeetingsForUser({
      userEmail,
      pastDays: duration,
      asAn,
    });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const OrgMeetingDetails = async (organizationId, pastDays) => {
  try {
    const getOrgMeetingDetails = httpsCallable(
      CloudFunctions,
      "getOrgMeetingDetails",
    );
    const res = await getOrgMeetingDetails({ organizationId, pastDays });
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const actionsSummary = async (userId, pastDays) => {
  try {
    const getActionsSummary = httpsCallable(
      CloudFunctions,
      "getActionsSummary2",
    );
    const res = await getActionsSummary({ userId, pastDays });
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const deleteUserData = httpsCallable(CloudFunctions, "removeUser");
    const res = await deleteUserData({ uid: "5FIhUI1OKuebIbj0vhrupGT6Ug82" });
    return res.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User is not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const res = await axios.delete(
      `${apiUrl.replace(/\/+$/, "")}/calendar/events/${encodeURIComponent(eventId)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const addOrUpdateStrategicGoal = async (goal, eventId) => {
  try {
    const strategicGoal = httpsCallable(CloudFunctions, "strategicGoal");
    const res = await strategicGoal({
      goal: goal.goal,
      color: goal.color,
      category: goal.category,
      categoryId: goal.categoryId,
      eventId,
    });
    return res.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Bulk goal edit from the Insights popup. Goes to the bot webhook rather than
// the strategicGoal callable because only the webhook can reach the background
// jobs container that rebuilds the caller's Strategic Focus insights afterwards.
export const updateStrategicGoals = async (updates) => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User is not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const res = await axios.post(
      `${apiUrl.replace(/\/+$/, "")}/insights/strategic-goals`,
      {
        updates: updates.map(({ eventId, goal, color, category, categoryId }) => ({
          eventId,
          goal,
          color,
          category,
          categoryId,
        })),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createCalendarEvent = async (event) => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User is not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const res = await axios.post(
      `${apiUrl.replace(/\/+$/, "")}/calendar/events`,
      event,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    if (res.data.status) {
      return res.data;
    }

    throw new Error(res.data.message || "Failed to create event");
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateCalendarEvent = async (eventId, event) => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User is not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const res = await axios.patch(
      `${apiUrl.replace(/\/+$/, "")}/calendar/events/${encodeURIComponent(eventId)}`,
      { event },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    if (res.data.status) {
      return res.data;
    }

    throw new Error(res.data.message || "Failed to update event");
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const findAvailableTimeApi = async (
  guestEmails,
  startDate,
  endDate,
  slotDurationMinutes,
) => {
  try {
    const findAvailableTime = httpsCallable(
      CloudFunctions,
      "findCommonAvailability",
    );
    const res = await findAvailableTime({
      guestEmails,
      startDate,
      endDate,
      slotDurationMinutes,
    });
    if (res.data.status) {
      return res.data;
    } else {
      throw new Error(res.data.message);
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getMeVsMeetingTimeForUser = async (userEmail, duration) => {
  try {
    const getMeVsMeetingTimeForUser = httpsCallable(
      CloudFunctions,
      "getMeVsMeetingTimeForUser",
    );
    const res = await getMeVsMeetingTimeForUser({
      userEmail,
      pastDays: duration,
    });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createOrganization = async (orgInfo, token) => {
  try {
    const createOrg = httpsCallable(CloudFunctions, "createOrganization");
    const res = await createOrg({
      org: orgInfo,
      secretKey: token,
    });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOrganizations = async (orgId) => {
  try {
    const getOrgs = httpsCallable(CloudFunctions, "getOrganizations");
    const res = await getOrgs({ orgId });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOrganizationDepartments = async (orgId) => {
  try {
    const getOrgDepartments = httpsCallable(
      CloudFunctions,
      "getOrganizationDepartments",
    );
    const res = await getOrgDepartments({ orgId });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const onBoardNewFinchUsersToOrg = async (orgId, users, clientSecret) => {
  try {
    const onboardFinchUsers = httpsCallable(
      CloudFunctions,
      "onBoardNewFinchUsersToOrg",
    );
    const res = await onboardFinchUsers({
      orgId,
      users,
      secretKey: clientSecret,
    });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const onBoardUsersToOrgAdmin = async (orgId, users) => {
  try {
    const onboardUsersAdmin = httpsCallable(
      CloudFunctions,
      "onBoardUsersToOrgAdmin",
    );
    const res = await onboardUsersAdmin({
      orgId,
      users,
    });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const removeUserAdmin = async (orgId, finchId) => {
  const removeUserAdmin = httpsCallable(CloudFunctions, "removeUserAdmin");
  const res = await removeUserAdmin({ orgId, finchId });
  if (!res.data.success) {
    throw new Error(res.data.message);
  }
  return true;
};

export const updateUserHourlyRateAdmin = async (orgId, finchId, amount) => {
  const updateRate = httpsCallable(CloudFunctions, "updateUserHourlyRateAdmin");
  const res = await updateRate({ orgId, finchId, amount });
  if (!res.data.success) {
    throw new Error(res.data.message);
  }
  return res.data;
};

export const getMeetingsFromIds = async (meetingIds, userEmail) => {
  try {
    const getMeetingsFromIds = httpsCallable(
      CloudFunctions,
      "getMeetingsFromIds",
    );
    const res = await getMeetingsFromIds({ meetingIds, userEmail });
    return res.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMeetingsForMyOrg = async (redisKey) => {
  try {
    const getMeetingsForMyOrg = httpsCallable(
      CloudFunctions,
      "getMeetingsForMyOrg",
      { timeout: 30000 },
    );
    const res = await getMeetingsForMyOrg({ redisKey });
    // const meetings = formatRedisMeetingsData(res.data);
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOrgGoalCategories = async (id) => {
  const q = query(
    collection(FirestoreDB, `organizations/${id}/goalCategories`),
    orderBy("createdAt", "desc"),
  );
  const snap = await getDocs(q);
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const createOrgGoalCategory = async (orgId, category) => {
  const colRef = collection(
    FirestoreDB,
    `organizations/${orgId}/goalCategories`,
  );
  const payload = {
    name: category.name,
    description: category.description || "",
    color: category.color,
    goals: Array.isArray(category.goals) ? category.goals : [],
    createdAt: serverTimestamp(),
  };
  const docRef = await addDoc(colRef, payload);
  return { id: docRef.id, ...payload };
};

export const updateOrgGoalCategory = async (orgId, categoryId, updates) => {
  const docRef = doc(
    FirestoreDB,
    `organizations/${orgId}/goalCategories/${categoryId}`,
  );
  const payload = {
    ...(updates.name !== undefined ? { name: updates.name } : {}),
    ...(updates.description !== undefined
      ? { description: updates.description }
      : {}),
    ...(updates.color !== undefined ? { color: updates.color } : {}),
    ...(Array.isArray(updates.goals) ? { goals: updates.goals } : {}),
  };
  await updateDoc(docRef, payload);
  return { id: categoryId, ...payload };
};

export const deleteOrgGoalCategory = async (orgId, categoryId) => {
  const docRef = doc(
    FirestoreDB,
    `organizations/${orgId}/goalCategories/${categoryId}`,
  );
  await deleteDoc(docRef);
  return { id: categoryId };
};

// Goals live inline in the category doc as an array of objects:
// goals: [{ name: "Education", description: "..." }, ...]
// They are positional — edit and delete address a goal by its array index.
const goalCategoryRef = (orgId, categoryId) =>
  doc(FirestoreDB, `organizations/${orgId}/goalCategories/${categoryId}`);

const readGoals = async (docRef) => {
  const snapshot = await getDoc(docRef);
  const data = snapshot.data() || {};
  return Array.isArray(data.goals) ? data.goals : [];
};

const toStoredGoal = (goal) => ({
  name: (goal?.name || "").trim(),
  description: (goal?.description || "").trim(),
});

export const addGoalToCategory = async (orgId, categoryId, goal) => {
  const docRef = goalCategoryRef(orgId, categoryId);
  const next = [...(await readGoals(docRef)), toStoredGoal(goal)];
  await updateDoc(docRef, { goals: next });
  return next;
};

export const updateGoalInCategory = async (orgId, categoryId, index, goal) => {
  const docRef = goalCategoryRef(orgId, categoryId);
  const goals = await readGoals(docRef);
  if (index < 0 || index >= goals.length) throw new Error("Invalid goal index");
  const next = goals.slice();
  next[index] = toStoredGoal(goal);
  await updateDoc(docRef, { goals: next });
  return next;
};

export const deleteGoalFromCategory = async (orgId, categoryId, index) => {
  const docRef = goalCategoryRef(orgId, categoryId);
  const goals = await readGoals(docRef);
  if (index < 0 || index >= goals.length) throw new Error("Invalid goal index");
  const next = goals.filter((_, i) => i !== index);
  await updateDoc(docRef, { goals: next });
  return next;
};

export const assignActionItems = async (actions) => {
  try {
    const assignActionItemsFunction = httpsCallable(
      CloudFunctions,
      "assignActionItems",
    );
    const response = await assignActionItemsFunction({ actions });
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getActionAttachmentDownloadUrl = async (data) => {
  try {
    const getActionAttachmentDownloadUrlFunction = httpsCallable(
      CloudFunctions,
      "getActionAttachmentDownloadUrl",
      { timeout: 15000 },
    );
    const response = await getActionAttachmentDownloadUrlFunction(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const unsendActionItem = async (data) => {
  try {
    const unsendActionItemFunction = httpsCallable(
      CloudFunctions,
      "unsendActionItem",
    );
    const response = await unsendActionItemFunction(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateOutboxActionItem = async (data) => {
  try {
    const updateOutboxActionItemFunction = httpsCallable(
      CloudFunctions,
      "updateOutboxActionItem",
    );
    const response = await updateOutboxActionItemFunction(data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const scanActions = async (currentItems) => {
  try {
    const scanActionsFunction = httpsCallable(CloudFunctions, "scanActions");
    const response = await scanActionsFunction({ currentItems });
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getUserInsights = async (email) => {
  try {
    const getUserInsightsFn = httpsCallable(CloudFunctions, "getInsights");
    const res = await getUserInsightsFn({ userEmail: email });
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsightsHistory = async (email, period) => {
  const getInsightsHistoryFn = httpsCallable(
    CloudFunctions,
    "getInsightsHistory"
  );
  const res = await getInsightsHistoryFn({ userEmail: email, period });
  if (!res.data?.status) {
    throw new Error(res.data?.message || "Unable to load insights history");
  }
  return res.data.data;
};

export const getCost = async (meetingId) => {
  try {
    const getCostFn = httpsCallable(CloudFunctions, "getCost");
    const res = await getCostFn({ meetingId });
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDepartmentUsers = async (orgId, departmentName) => {
  try {
    const getDepartmentUsersFn = httpsCallable(
      CloudFunctions,
      "getDepartmentUsers",
    );
    const res = await getDepartmentUsersFn({ orgId, departmentName });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const optimizeNextWeek = async () => {
  try {
    const optimizeNextWeekFn = httpsCallable(
      CloudFunctions,
      "optimizeNextWeek",
    );
    const res = await optimizeNextWeekFn();
    console.log(res);
    if (!res.data.success) {
      throw new Error(res.data.message);
    }
    return res.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const impersonate = async (userId) => {
  try {
    const impersonateFn = httpsCallable(CloudFunctions, "impersonate");
    const res = await impersonateFn({ userId });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const stopImpersonation = async () => {
  try {
    const stopImpersonationFn = httpsCallable(
      CloudFunctions,
      "stopImpersonation"
    );
    const res = await stopImpersonationFn();
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOrgUsers = async (orgId) => {
  try {
    const getAllUsersForImpersonationFn = httpsCallable(
      CloudFunctions,
      "getAllUsersForImpersonation",
    );
    const res = await getAllUsersForImpersonationFn({ orgId });
    return res.data.users;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSummaryActions = async (eventId, actions) => {
  try {
    const docRef = doc(FirestoreDB, `summaries/${eventId}`);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      throw new Error(`Summary not found for eventId ${eventId}`);
    }
    await setDoc(docRef, { tasksAssigned: actions }, { merge: true });
    return true;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const unscheduleMeetingBot = async (eventId) => {
  try {
    const unscheduleMeetingBotFn = httpsCallable(
      CloudFunctions,
      "unscheduleMeetingBot",
    );
    const response = await unscheduleMeetingBotFn({ eventId });
    return response.data;
  } catch (error) {
    console.error("unscheduleMeetingBot error:", error);
    throw error;
  }
};

export const sendMeetingBotNow = async (eventId) => {
  try {
    const sendMeetingBotNowFn = httpsCallable(
      CloudFunctions,
      "sendMeetingBotNow",
    );
    const response = await sendMeetingBotNowFn({ eventId });
    return response.data;
  } catch (error) {
    console.error("sendMeetingBotNow error:", error);
    throw error;
  }
};

export const sendMeetingBotOnJoin = async (eventId) => {
  try {
    const sendMeetingBotOnJoinFn = httpsCallable(
      CloudFunctions,
      "sendMeetingBotOnJoin",
    );
    const response = await sendMeetingBotOnJoinFn({ eventId });
    return response.data;
  } catch (error) {
    console.error("sendMeetingBotOnJoin error:", error);
    throw error;
  }
};

export const evaluateMeetingBotPrompt = async (eventId) => {
  try {
    const evaluateMeetingBotPromptFn = httpsCallable(
      CloudFunctions,
      "evaluateMeetingBotPrompt",
    );
    const response = await evaluateMeetingBotPromptFn({ eventId });
    return response.data;
  } catch (error) {
    console.error("evaluateMeetingBotPrompt error:", error);
    throw error;
  }
};

export const searchMeetingSummaries = async (
  query,
  page = 1,
  perPage = 20,
  filters = {},
) => {
  try {
    // Get Firebase auth token
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    // Get API base URL from environment variable
    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    // Make API request
    const response = await axios.post(
      `${apiUrl}/search`,
      {
        query,
        page,
        perPage,
        ...filters,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );
    console.log("searchMeetingSummaries response:", response.data);
    return response.data;
  } catch (error) {
    console.error("searchMeetingSummaries error:", error);
    throw error;
  }
};

const normalizeAssistantChatResponse = (data = {}) => ({
  assistantReply:
    data?.assistantReply || "I found a response, but it could not be formatted.",
  createdActions: Array.isArray(data?.createdActions) ? data.createdActions : [],
  actionReceipts: Array.isArray(data?.actionReceipts)
    ? data.actionReceipts
    : [],
  calendarEventDrafts: Array.isArray(data?.calendarEventDrafts)
    ? data.calendarEventDrafts
    : [],
  calendarEventDeletions: Array.isArray(data?.calendarEventDeletions)
    ? data.calendarEventDeletions
    : [],
  calendarEventUpdates: Array.isArray(data?.calendarEventUpdates)
    ? data.calendarEventUpdates
    : [],
  emailDrafts: Array.isArray(data?.emailDrafts) ? data.emailDrafts : [],
  sources: Array.isArray(data?.sources) ? data.sources : [],
  meta: data?.meta || {},
});

const parseAssistantStreamFrame = (frame) => {
  const lines = frame.split(/\r?\n/);
  let eventName = "message";
  const dataLines = [];

  lines.forEach((line) => {
    if (!line || line.startsWith(":")) return;

    if (line.startsWith("event:")) {
      eventName = line.slice("event:".length).trim() || eventName;
      return;
    }

    if (line.startsWith("data:")) {
      dataLines.push(line.slice("data:".length).trimStart());
    }
  });

  if (!dataLines.length) {
    return { eventName, data: null };
  }

  return {
    eventName,
    data: JSON.parse(dataLines.join("\n")),
  };
};

export const sendAssistantChatMessageStream = async ({
  message,
  turnId,
  chatHistory = [],
  filters = {},
  onProgress,
  voiceMode = false,
  onDelta,
  onAck,
  signal,
} = {}) => {
  try {
    const trimmedMessage = typeof message === "string" ? message.trim() : "";
    if (!trimmedMessage) {
      throw new Error("Message is required");
    }

    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const response = await fetch(`${apiUrl}/assistant/chat`, {
      method: "POST",
      headers: {
        accept: "text/event-stream",
        "content-type": "application/json",
        authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        message: trimmedMessage,
        ...(turnId ? { turnId } : {}),
        chatHistory: Array.isArray(chatHistory) ? chatHistory : [],
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...(voiceMode ? { voiceMode: true } : {}),
        ...filters,
      }),
      signal,
    });

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(errorBody || `Assistant request failed: ${response.status}`);
    }

    if (!response.body?.getReader) {
      throw new Error("Streaming responses are not supported in this browser.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let finalPayload = null;

    const handleFrame = (frame) => {
      const trimmedFrame = frame.trim();
      if (!trimmedFrame) return;

      const { eventName, data } = parseAssistantStreamFrame(trimmedFrame);
      if (!data) return;

      if (eventName === "progress") {
        onProgress?.(data);
        return;
      }

      if (eventName === "delta") {
        if (typeof data.text === "string" && data.text) {
          onDelta?.(data.text);
        }
        return;
      }

      if (eventName === "ack") {
        if (typeof data.text === "string" && data.text) {
          onAck?.(data.text);
        }
        return;
      }

      if (eventName === "final") {
        finalPayload = data;
        return;
      }

      if (eventName === "error") {
        throw new Error(data.label || data.error || "Assistant stream failed");
      }
    };

    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
      const frames = buffer.split(/\r?\n\r?\n/);
      buffer = frames.pop() || "";
      frames.forEach(handleFrame);

      if (done) {
        if (buffer.trim()) {
          handleFrame(buffer);
        }
        break;
      }
    }

    if (!finalPayload) {
      throw new Error("Assistant stream ended before a final response.");
    }

    return normalizeAssistantChatResponse(finalPayload);
  } catch (error) {
    console.error("sendAssistantChatMessageStream error:", error);
    throw error;
  }
};

// Streams TTS audio (raw linear16 mono 24 kHz) for one voice-mode text
// fragment through the backend ElevenLabs proxy. Delivers chunks to onChunk
// as they arrive; resolves when the stream ends.
export const streamAssistantVoiceTtsAudio = async ({ text, signal, onChunk }) => {
  const token = await FirebaseAuth.currentUser?.getIdToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
  if (!apiUrl) {
    throw new Error(
      "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
    );
  }

  const response = await fetch(
    `${apiUrl.replace(/\/+$/, "")}/assistant/voice/tts`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ text }),
      signal,
    },
  );

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody?.error || "Voice synthesis failed");
  }

  const reader = response.body.getReader();
  while (true) {
    const { value, done } = await reader.read();
    if (value?.byteLength) {
      onChunk?.(value);
    }
    if (done) break;
  }
};

// Mints a short-lived Deepgram token (30s TTL) so the browser can open
// Flux STT / Aura TTS websockets directly during a voice session.
export const fetchAssistantVoiceToken = async () => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const response = await fetch(
      `${apiUrl.replace(/\/+$/, "")}/assistant/voice/token`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      },
    );

    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody?.error || "Voice session token failed");
    }

    const data = await response.json();
    if (!data?.accessToken) {
      throw new Error("Voice session token response was empty");
    }

    return { accessToken: data.accessToken, expiresIn: data.expiresIn };
  } catch (error) {
    console.error("fetchAssistantVoiceToken error:", error);
    throw error;
  }
};

export const refreshNextMeetingCard = async ({
  eventId,
  eventFingerprint,
  localDate,
  storageScope,
} = {}) => {
  try {
    if (!eventId) {
      throw new Error("eventId is required");
    }

    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const response = await fetch(
      `${apiUrl.replace(/\/+$/, "")}/assistant/next-meeting-card/refresh`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          eventId,
          eventFingerprint,
          localDate,
          storageScope,
        }),
      },
    );

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(
        errorBody || `Next meeting card refresh failed: ${response.status}`,
      );
    }

    return response.json();
  } catch (error) {
    console.error("refreshNextMeetingCard error:", error);
    throw error;
  }
};

export const refreshAmbientAgentSuggestions = async ({ localDate } = {}) => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const response = await fetch(
      `${apiUrl.replace(/\/+$/, "")}/assistant/ambient-agent/refresh`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ localDate }),
      },
    );

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(
        errorBody || `Ambient agent refresh failed: ${response.status}`,
      );
    }

    return response.json();
  } catch (error) {
    console.error("refreshAmbientAgentSuggestions error:", error);
    throw error;
  }
};

// Top two cards of the Organization insights page. The first open of a view
// builds the brief on the server (about 10 to 20 seconds); later opens read it
// from the cache.
export const getOrgBrief = async ({ period, perspective }) => {
  const token = await FirebaseAuth.currentUser?.getIdToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
  if (!apiUrl) {
    throw new Error("REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured.");
  }

  const response = await fetch(`${apiUrl.replace(/\/+$/, "")}/assistant/org-brief`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ period, perspective }),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(errorBody || `Organization brief failed: ${response.status}`);
  }

  return response.json();
};

export const transcribeAssistantAudio = async ({ audioBlob, durationMs } = {}) => {
  try {
    if (!(audioBlob instanceof Blob) || !audioBlob.size) {
      throw new Error("Audio recording is required");
    }

    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const formData = new FormData();
    formData.append(
      "audio",
      audioBlob,
      `assistant-recording.${audioBlob.type.includes("mp4") ? "mp4" : "webm"}`,
    );
    formData.append("durationMs", String(Math.round(durationMs || 0)));

    const response = await fetch(`${apiUrl}/assistant/transcribe`, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data?.error || `Transcription failed: ${response.status}`);
    }

    const transcript =
      typeof data?.transcript === "string" ? data.transcript.trim() : "";
    if (!transcript) {
      throw new Error("No speech was detected");
    }

    return {
      transcript,
    };
  } catch (error) {
    console.error("transcribeAssistantAudio error:", error);
    throw error;
  }
};

export const getRecordingArtifacts = async (eventId, botId) => {
  try {
    // Get Firebase auth token
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    // Get API base URL from environment variable
    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    // Make API request
    const response = await axios.get(`${apiUrl}/artifacts`, {
      params: {
        eventId,
        botId,
      },
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    // Validate response structure
    if (!response.data?.recording?.url) {
      throw new Error("Recording URL not found in response");
    }

    // Return full recording object with url and start_timestamp_ms
    return response.data.recording;
  } catch (error) {
    console.error("getRecordingArtifacts error:", error);

    // Wrap error with additional context
    const wrappedError = new Error(
      `Failed to fetch recording artifacts for event ${eventId}: ${error.message}`,
    );
    wrappedError.originalError = error;
    wrappedError.eventId = eventId;
    wrappedError.botId = botId;

    // Preserve response status for error handling
    if (error.response) {
      wrappedError.status = error.response.status;
      wrappedError.statusText = error.response.statusText;
    }

    throw wrappedError;
  }
};

export const getTranscript = async (eventId, botId) => {
  try {
    // Get Firebase auth token
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    // Get API base URL from environment variable
    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    // Make API request
    const response = await axios.get(`${apiUrl}/artifacts/transcript`, {
      params: {
        eventId,
        botId,
      },
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    // Validate response structure - expecting an array of transcript objects
    if (!response.data || !Array.isArray(response.data)) {
      throw new Error("Invalid transcript data format");
    }

    return response.data;
  } catch (error) {
    console.error("getTranscript error:", error);

    // Wrap error with additional context
    const wrappedError = new Error(
      `Failed to fetch transcript for event ${eventId}: ${error.message}`,
    );
    wrappedError.originalError = error;
    wrappedError.eventId = eventId;
    wrappedError.botId = botId;

    // Preserve response status for error handling
    if (error.response) {
      wrappedError.status = error.response.status;
      wrappedError.statusText = error.response.statusText;
    }

    throw wrappedError;
  }
};

export const zoomOAuth = async () => {
  try {
    // Get Firebase auth token
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    // Get API base URL from environment variable
    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    // Make API request
    const response = await axios.get(`${apiUrl}/zoom/zoom_oauth`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    console.log("get zoom auth response:", response.data);

    // Validate response structure - expecting an array of transcript objects
    if (!response.data.url) {
      throw new Error("Invalid oauth data format");
    }

    return response.data;
  } catch (error) {
    console.error("zoomOauth error:", error);
    throw error;
  }
};

export const getZoomMeetingSdkSignature = async (meetingNumber) => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const response = await axios.post(
      `${apiUrl}/zoom/meeting-sdk/signature`,
      { meetingNumber },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.data?.signature) {
      throw new Error("Invalid Zoom Meeting SDK signature response");
    }

    return response.data;
  } catch (error) {
    console.error("getZoomMeetingSdkSignature error:", error);
    throw error;
  }
};

export const getZoomMeetingSdkZakToken = async () => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const response = await axios.post(
      `${apiUrl}/zoom/meeting-sdk/zak-token`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.data?.zakToken) {
      throw new Error("Invalid Zoom Meeting SDK ZAK token response");
    }

    return response.data;
  } catch (error) {
    console.error("getZoomMeetingSdkZakToken error:", error);
    throw error;
  }
};

export const googleOAuthStart = async (returnTo = "/onboarding-calendar") => {
  try {
    const token = await FirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const apiUrl = process.env.REACT_APP_GT_WEBHOOK_API_URL;
    if (!apiUrl) {
      throw new Error(
        "REACT_APP_GT_WEBHOOK_API_URL environment variable is not configured. Please set it in your .env file.",
      );
    }

    const response = await axios.get(`${apiUrl}/google/oauth/start`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
      params: {
        returnTo,
      },
    });

    if (!response.data?.url) {
      throw new Error("Invalid oauth data format");
    }

    return response.data;
  } catch (error) {
    console.error("googleOAuthStart error:", error);
    throw error;
  }
};

export const deleteGoogleChannel = async () => {
  try {
    const deleteGoogleChannelFn = httpsCallable(
      CloudFunctions,
      "deleteGoogleChannel",
    );
    const res = await deleteGoogleChannelFn();
    return res.data;
  } catch (error) {
    console.error("deleteGoogleChannel error:", error);
    throw error;
  }
};
